import useSEO from '../../hooks/useSEO';

export default function TermsConditions() {
  // SEO dinámico
  useSEO({
    title: "Términos y Condiciones | SEOgenia",
    description: "Términos y Condiciones de uso del sitio web SEOgenia. Aviso legal, condiciones de uso, propiedad intelectual y responsabilidades.",
    keywords: "términos condiciones, aviso legal, condiciones uso, términos servicio",
    canonical: "https://seogenia.es/terminos-condiciones",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Términos y Condiciones",
      "description": "Términos y Condiciones de SEOgenia",
      "url": "https://seogenia.es/terminos-condiciones"
    }
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">Términos y Condiciones</h1>
          <p className="text-lg sm:text-xl opacity-90">Última actualización: 15 de enero de 2025</p>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Información General</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos:
            </p>
            <div className="bg-gray-50 rounded-xl p-6">
              <p className="text-gray-700"><strong>Denominación social:</strong> SEOgenia</p>
              <p className="text-gray-700"><strong>Domicilio:</strong> Madrid, España</p>
              <p className="text-gray-700"><strong>Email:</strong> info@seogenia.es</p>
              <p className="text-gray-700"><strong>Teléfono:</strong> +34 659 357 423</p>
              <p className="text-gray-700"><strong>Sitio Web:</strong> https://seogenia.es</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Objeto</h2>
            <p className="text-gray-700 leading-relaxed">
              El presente aviso legal regula el uso del sitio web seogenia.es (en adelante, LA WEB), del que es titular SEOgenia. La navegación por el sitio web de SEOgenia atribuye la condición de usuario del mismo e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal, que pueden sufrir modificaciones.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Condiciones de Uso</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              El Usuario se compromete a utilizar el Sitio Web, los contenidos y servicios de conformidad con la Ley, el presente Aviso Legal, las buenas costumbres y el orden público. Del mismo modo, el Usuario se obliga a no utilizar el Sitio Web o los servicios que se presten a través del mismo con fines o efectos ilícitos o contrarios al contenido del presente Aviso Legal, lesivos de los intereses o derechos de terceros, o que de cualquier forma pueda dañar, inutilizar, sobrecargar o deteriorar el Sitio Web o impedir la normal utilización o disfrute del Sitio Web por parte de los Usuarios.
            </p>
            <p className="text-gray-700 leading-relaxed">
              En particular, y a título meramente indicativo y no exhaustivo, el Usuario se compromete a no transmitir, difundir o poner a disposición de terceros informaciones, datos, contenidos, mensajes, gráficos, dibujos, archivos de sonido y/o imagen, fotografías, grabaciones, software y, en general, cualquier clase de material que:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
              <li>Sea contrario, desprecie o atente contra los derechos fundamentales y las libertades públicas reconocidas constitucionalmente, en tratados internacionales y otras normas vigentes.</li>
              <li>Induzca, incite o promueva actuaciones delictivas, denigratorias, difamatorias, violentas o, en general, contrarias a la ley, a la moral y al orden público.</li>
              <li>Induzca, incite o promueva actuaciones, actitudes o pensamientos discriminatorios por razón de sexo, raza, religión, creencias, edad o condición.</li>
              <li>Incorpore, ponga a disposición o permita acceder a productos, elementos, mensajes y/o servicios delictivos, violentos, ofensivos, nocivos, degradantes o, en general, contrarios a la ley, a la moral y al orden público.</li>
              <li>Induzca o pueda inducir a un estado inaceptable de ansiedad o temor.</li>
              <li>Induzca o incite a involucrarse en prácticas peligrosas, de riesgo o nocivas para la salud y el equilibrio psíquico.</li>
              <li>Se encuentra protegido por la legislación en materia de protección intelectual o industrial perteneciente a SEOgenia o a terceros sin que haya sido autorizado el uso que se pretenda realizar.</li>
              <li>Sea contrario al honor, a la intimidad personal y familiar o a la propia imagen de las personas.</li>
              <li>Constituya cualquier tipo de publicidad.</li>
              <li>Incluya cualquier tipo de virus o programa que impida el normal funcionamiento del Sitio Web.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Propiedad Intelectual e Industrial</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Todos los contenidos del Sitio Web, entendiendo por estos a título meramente enunciativo los textos, fotografías, gráficos, imágenes, iconos, tecnología, software, links y demás contenidos audiovisuales o sonoros, así como su diseño gráfico y códigos fuente (en adelante, los "Contenidos"), son propiedad intelectual de SEOgenia o de terceros, sin que puedan entenderse cedidos al Usuario ninguno de los derechos de explotación reconocidos por la normativa vigente en materia de propiedad intelectual sobre los mismos.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Las marcas, nombres comerciales o signos distintivos son titularidad de SEOgenia o terceros, sin que pueda entenderse que el acceso al Sitio Web atribuya ningún derecho sobre las citadas marcas, nombres comerciales y/o signos distintivos.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Asimismo, los Contenidos son propiedad intelectual de SEOgenia o de terceros, sin que puedan entenderse cedidos al Usuario, en virtud de lo establecido en este Aviso Legal, ninguno de los derechos de explotación que existen o puedan existir sobre dichos Contenidos más allá de lo estrictamente necesario para el correcto uso del Sitio Web.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Exclusión de Garantías y Responsabilidad</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              SEOgenia no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del portal o la transmisión de virus o programas maliciosos o lesivos en los contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.
            </p>
            <p className="text-gray-700 leading-relaxed">
              SEOgenia se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su portal, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados en su portal.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Enlaces</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En el caso de que en el Sitio Web se dispusiesen enlaces o hipervínculos hacía otros sitios de Internet, SEOgenia no ejercerá ningún tipo de control sobre dichos sitios y contenidos. En ningún caso SEOgenia asumirá responsabilidad alguna por los contenidos de algún enlace perteneciente a un sitio web ajeno, ni garantizará la disponibilidad técnica, calidad, fiabilidad, exactitud, amplitud, veracidad, validez y constitucionalidad de cualquier material o información contenida en ninguno de dichos hipervínculos u otros sitios de Internet.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Igualmente la inclusión de estas conexiones externas no implicará ningún tipo de asociación, fusión o participación con las entidades conectadas.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Protección de Datos</h2>
            <p className="text-gray-700 leading-relaxed">
              Para utilizar algunos de los Servicios, el Usuario debe proporcionar previamente ciertos datos de carácter personal. SEOgenia tratará automatizadamente estos datos y aplicará las correspondientes medidas de seguridad, todo ello en cumplimiento del RGPD, LOPDGDD y LSSI. El Usuario puede acceder a la política seguida en el tratamiento de los datos personales, así como el establecimiento de las finalidades previamente establecidas, en las condiciones definidas en la Política de Privacidad.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Cookies</h2>
            <p className="text-gray-700 leading-relaxed">
              SEOgenia se reserva el derecho de utilizar la tecnología "cookie" en el Sitio Web, a fin de reconocerlo como Usuario frecuente y personalizar el uso que realice del Sitio Web mediante la preselección de su idioma, o contenidos más deseados o específicos. Para más información consulte nuestra Política de Cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Legislación Aplicable y Jurisdicción</h2>
            <p className="text-gray-700 leading-relaxed">
              La relación entre SEOgenia y el Usuario se regirá por la normativa española vigente y cualquier controversia se someterá a los Juzgados y tribunales de la ciudad de Madrid, España.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contacto</h2>
            <p className="text-gray-700 leading-relaxed">
              Para cualquier consulta sobre estos Términos y Condiciones, puede contactar con nosotros:
            </p>
            <div className="bg-gray-50 rounded-xl p-6 mt-4">
              <p className="text-gray-700"><strong>Email:</strong> info@seogenia.es</p>
              <p className="text-gray-700"><strong>Teléfono:</strong> +34 659 357 423</p>
              <p className="text-gray-700"><strong>Dirección:</strong> Madrid, España</p>
            </div>
          </section>
        </div>

        {/* Back Button */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-500 font-semibold transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            Volver al inicio
          </a>
        </div>
      </div>
    </div>
  );
}
